module.exports = __webpack_public_path__ + "img/regRight.c9f1c512.png";